var exports = {
  "Z2": "Gallery__XdUz4z",
  "mO": "Wrapper__hOIlmj",
  "fh": "Cell__TzyA5Y",
  "YZ": "Eyebrow___25PqC",
  "hE": "Title__fXNA3N",
  "dK": "Pagination__ICsh4U",
  "L7": "PaginationButton__vV448R",
  "$L": "PaginationLabel__ky9zNa",
  "xA": "Grid__Q-n-Is",
  "Dn": "Figure__7Ey6jv",
  "_V": "Image__vtq620",
  "HL": "Caption__Gw8_RM",
  "xW": "ImageWrapper__7nmlBu",
};

module.exports = exports;
